// Spreadsheet upload acceptance shared by the SpAdmin bulk-import modals
// (Assign Specialties, RSVP invites).
export const ACCEPTED_EXTENSIONS = [".csv", ".xlsx", ".xls"];

export function isAcceptedFile(file) {
  return ACCEPTED_EXTENSIONS.some((ext) => file?.name?.toLowerCase().endsWith(ext));
}
